import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface PaymentHistoryFailedIconProps {
  width?: number;
  height?: number;
}

const PaymentHistoryFailedIcon: React.FC<PaymentHistoryFailedIconProps> = ({
  width = 20,
  height = 20
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.834 10.833a.834.834 0 01-1.667 0V6.666a.834.834 0 011.667 0v4.167zM10 14.166a.834.834 0 110-1.667.834.834 0 010 1.667zm0-12.5a8.333 8.333 0 100 16.667 8.333 8.333 0 100-16.666z"
        fill="#E12D39"
      />
    </svg>
  </SVGUniqueID>
);

export { PaymentHistoryFailedIcon };
